import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import Modal from '../../components/modal';
import ToastHandler from '../../components/toasthandler';
import Loader from '../../components/loader';
import Crypto from './crypto';
import Exchange from './exchange';
import Recent from './recent';
import Orders from './orders';
import MyOrders from './myorders';
import ChartContainer from './chartcontainer';
import PusherClient from '../../lib/pusher';
import AssetConfig from '../../components/assetconfig';

import 'react-toastify/dist/ReactToastify.min.css';

import {
  fetchOrders,
  fetchLatestOrders,
  fetchOpenOrders,
  fetchBalance,
  fetchOhlc,
} from '../../actions';

const qs = require('query-string');

const cookies = new Cookies();

class Trade extends Component {
  constructor(props) {
    super(props);
    const { user, enabledPairs, filterParams, usePair, exchA, exchB } = this.props;
    this.state = {
      enabledPairs,
      filterParams,
      pair: usePair || 'GOLDBTC',
      exchA: exchA || 'gold',
      exchB: exchB || 'btc',
      modalComponent: null,
      currentPair: '',
      latestPrice: '',
      balanceLoading: true,
      ohlcLoading: true,
      buyLoading: true,
      sellLoading: true,
      latestLoading: true,
      openLoading: true,
      exchangeLoading: true,
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.setPair = this.setPair.bind(this);
    this.dataFetch = this.dataFetch.bind(this);
    this.latestPrice = this.latestPrice.bind(this);
    this.currencySign = this.currencySign.bind(this);
    this.toLocaleFixed = this.toLocaleFixed.bind(this);
    this.updateBalances = this.updateBalances.bind(this);
    this.updateOrders = this.updateOrders.bind(this);
    this.updateOpenOrders = this.updateOpenOrders.bind(this);
    this.updateDataLooped = this.updateDataLooped.bind(this);
    this.isOfType = this.isOfType.bind(this);
  }

  componentDidMount() {
    this.dataFetch();
    let channelName = 'trade';
    if (process.env.NODE_ENV === 'production') {
      channelName = `private-${channelName}`;
    }
    const { user } = this.props;
    const { publicToken } = user.me;

    const channel = PusherClient().subscribe(channelName);

    if (channel) {
      const topic = 'global';
      channel.bind(topic, data => {
        switch (data.type) {
          case 'orders':
            this.updateOrders(data.pair, true);
            return;
          case 'trades':
            // TODO
            // update trades only
            return;
          case 'ohlc':
            // TODO
            return;
          case 'simontest':
            console.log(new Date());
            return;
          // case 'balances':
          //   this.updateBalances();
          //   return;
          default:
        }
      });

      if (publicToken) {
        const ptopic = `private.${publicToken}`;
        channel.bind(ptopic, data => {
          switch (data.type) {
            case 'orders':
              this.updateOpenOrders(data.pair, true);
              return;
            case 'balances':
              this.updateBalances(data.pair, true);
              return;
            case 'simontest':
              alert(data.type);
              return;
            default:
          }
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { pair } = this.state;
    if (prevState.pair !== pair) {
      this.setState({
        balanceLoading: true,
        ohlcLoading: true,
        buyLoading: true,
        sellLoading: true,
        latestLoading: true,
        openLoading: true,
        exchangeLoading: true,
      });
    }
    this.dataFetch();
  }

  componentWillUnmount() {
    // clearInterval(this.dataLoopInterval);
    let channelName = 'trade';
    if (process.env.NODE_ENV === 'production') {
      channelName = `private-${channelName}`;
    }
    PusherClient().unsubscribe(channelName);
  }

  setPair(event) {
    const { getPairAssets } = this.props;
    let exchA;
    let exchB;
    const value = event.target.value;
    const assets = getPairAssets(value);
    if (assets && assets.exchA && assets.exchB) {
      exchA = assets.exchA;
      exchB = assets.exchB;
    }
    this.setState({ pair: event.target.value, exchA, exchB });
    this.props.history.push({ search: '?pair=' + event.target.value });
    cookies.set('vtpar', event.target.value, { host: process.env.HOSTNAME, path: '/' });
  }

  updateDataLooped() {
    const { dispatch } = this.props;
    const { pair } = this.state;

    const ohlcData = {
      pair,
    };
    const latestData = {
      fx: true,
      pair,
      limit: 10,
    };
    dispatch(fetchBalance({}));
    dispatch(fetchOhlc(ohlcData));
    dispatch(fetchLatestOrders(latestData)).then(res => {
      this.latestPrice();
    });
  }

  updateBalances(pair, pusher) {
    const { dispatch } = this.props;
    const { currentPair } = this.state;

    if (!pair) {
      return;
    }

    if (currentPair !== pair) {
      return;
    }

    const latestData = {
      fx: true,
      pair,
      limit: 10,
      push: pusher,
    };

    dispatch(fetchBalance({}));
    dispatch(fetchLatestOrders(latestData)).then(res => {
      this.latestPrice();
    });
  }

  updateOrders(pair, pusher) {
    if (!pair) {
      return;
    }
    const { dispatch, user } = this.props;
    const { currentPair } = this.state;

    // make sure we're looking at the pair that's just been updated
    if (currentPair !== pair) {
      return;
    }

    let myCurrency;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      myCurrency = user.me.defaults.currencyHandle;
    }
    const buyData = {
      pair,
      liquidity: true,
      type: 'BUY',
      fx: myCurrency,
      push: pusher,
    };
    const sellData = {
      pair,
      liquidity: true,
      type: 'SELL',
      fx: myCurrency,
      push: pusher,
    };
    // const ohlcData = {
    //   pair,
    // };
    // dispatch(fetchOhlc(ohlcData));
    dispatch(fetchOrders(buyData));
    dispatch(fetchOrders(sellData));
  }

  updateOpenOrders(pair, pusher) {
    const { dispatch } = this.props;

    const { currentPair } = this.state;

    // make sure we're looking at the pair that's just been updated
    if (currentPair !== pair) {
      return;
    }

    const openData = {
      pair,
      status: 'OPEN',
      queued: true,
      self: true,
      push: pusher,
    };
    dispatch(fetchOpenOrders(openData));
  }

  dataFetch() {
    const { dispatch, user } = this.props;
    const { currentPair, pair } = this.state;
    let myCurrency;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      myCurrency = user.me.defaults.currencyHandle;
    }

    if (currentPair !== pair) {
      const buyData = {
        pair,
        liquidity: true,
        type: 'BUY',
        fx: myCurrency,
      };
      const sellData = {
        pair,
        liquidity: true,
        type: 'SELL',
        fx: myCurrency,
      };
      const latestData = {
        fx: true,
        pair,
        limit: 10,
      };
      const ohlcData = {
        pair,
      };
      const openData = {
        pair,
        status: 'OPEN',
        queued: true,
        self: true,
      };
      dispatch(fetchBalance({})).then(res => {
        if (res.type === 'FETCH_BALANCES_SUCCESS') {
          this.setState({ balanceLoading: false, exchangeLoading: false, });
        }
      });
      dispatch(fetchOhlc(ohlcData)).then(res => {
        if (res.type === 'FETCH_OHLC_SUCCESS') {
          this.setState({ ohlcLoading: false });
        }
      });
      dispatch(fetchOrders(buyData)).then(res => {
        if (res.type === 'FETCH_ORDER_LIQUIDITY_SUCCESS') {
          this.setState({ buyLoading: false });
        }
      });
      dispatch(fetchOrders(sellData)).then(res => {
        if (res.type === 'FETCH_ORDER_LIQUIDITY_SUCCESS') {
          this.setState({ sellLoading: false });
        }
      });
      dispatch(fetchLatestOrders(latestData)).then(res => {
        if (res.type === 'FETCH_LATEST_ORDERS_SUCCESS') {
          this.setState({ latestLoading: false });
          this.latestPrice();
        }
      });
      dispatch(fetchOpenOrders(openData)).then(res => {
        if (res.type === 'FETCH_OPEN_ORDERS_SUCCESS') {
          this.setState({ openLoading: false });
        }
      });
      this.setState({ currentPair: pair });
    }
  }

  currencySign(val) {
    if (val === 'EURCENT') {
      return '\u20AC';
    }
    if (val === 'CENT') {
      return '\u0024';
    }
  }

  toLocaleFixed(num, dec) {
    let localeFixed;
    if (num && dec) {
      localeFixed = num.toLocaleString(
        undefined,
        {
          minimumFractionDigits: dec,
          maximumFractionDigits: dec,
        },
      );
    }
    return localeFixed;
  }

  toggleModal(component) {
    this.setState({
      modalComponent: component,
    });
  }

  latestPrice() {
    const { orders } = this.props;

    if (orders && orders.latest && orders.latest.length) {
      this.setState({ latestPrice: orders.latest[0].price });
    }
  }

  isOfType(asset, type) {
    let useAsset;
    if (asset) {
      useAsset = asset.toUpperCase();
    }
    let useType;
    if (type) {
      useType = type.toUpperCase();
    }
    let typeAssets;
    let isType;
    if (AssetConfig && AssetConfig.length) {
      typeAssets = AssetConfig.filter((item) => {
        return item.type === useType;
      });
    }
    if (typeAssets && typeAssets.length) {
      isType = typeAssets.find((item) => {
        return item.handle === useAsset;
      });
    }
    if (isType) {
      return true;
    }
    return false;
  }

  render() {
    const { user, errors, orders, success, getPairAssets } = this.props;

    const { exchA, exchB, pair, currentPair, latestPrice, buyLoading, sellLoading, latestLoading, openLoading, exchangeLoading, enabledPairs } = this.state;

    let tradePairs;
    if (enabledPairs && enabledPairs.length) {
      tradePairs = enabledPairs.map((pair) => {
        const pairAssets = getPairAssets(pair);
        let assetA;
        let assetB;
        if (pairAssets) {
          assetA = pairAssets.exchA;
          assetB = pairAssets.exchB;
        }
        return (
          {
            name: assetA + ' / ' + assetB,
            pair,
            exchA: assetA,
            exchB: assetB,
          }
        );
      });
    }

    return (
      <div className="trade-con">
        <div className="grid-x orders">
          <ToastHandler
            errors={errors}
            success={success}
          />
          {this.state.modalComponent && (
            <Modal
              noclose={user.resetCode}
              toggleModal={this.toggleModal}
              modalComponent={this.state.modalComponent}
            />
          )}
          <Crypto
            setPair={this.setPair}
            pair={pair}
            tradePairs={tradePairs}
            exchA={exchA}
            exchB={exchB}
            getPairAssets={getPairAssets}
          />
        </div>
        <div className="trade-charts">
          <div>
            { exchangeLoading ? (
              <div className="cell panel">
                <div className="panel-label">
                  BUY / SELL
                </div>
                <div className="center-loader">
                  <Loader logo />
                </div>
              </div>
            ) : (
              <Exchange
                pair={pair}
                latestPrice={latestPrice}
                exchA={exchA}
                exchB={exchB}
                isOfType={this.isOfType}
              />
            )}
            { openLoading ? (
              <div className="cell panel">
                <div className="panel-label">
                  Open Orders
                </div>
                <div className="center-loader">
                  <Loader logo />
                </div>
              </div>
            ) : (
              <MyOrders
                pair={pair}
                exchA={exchA}
                exchB={exchB}
                toggleModal={this.toggleModal}
                isOfType={this.isOfType}
              />
            )}
            { latestLoading ? (
              <div className="cell panel">
                <div className="panel-label">
                  All Latest Trades
                </div>
                <div className="center-loader">
                  <Loader logo />
                </div>
              </div>
            ) : (
              <Recent
                pair={pair}
                exchA={exchA}
                exchB={exchB}
                isOfType={this.isOfType}
              />
            )}
          </div>
          <div>
            {buyLoading || sellLoading ? (
              <div className="cell panel">
                <div className="panel-label">
                  Orderbook
                </div>
                <div className="center-loader">
                  <Loader logo />
                </div>
              </div>
            ) : (
              <Orders
                pair={pair}
                currencySign={this.currencySign}
                toLocaleFixed={this.toLocaleFixed}
                exchA={exchA}
                exchB={exchB}
                isOfType={this.isOfType}
              />
            )}
            <ChartContainer
              exchA={exchA}
              exchB={exchB}
              buyLoading={buyLoading}
              sellLoading={sellLoading}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  errors: state.order.errors,
  success: state.order.success,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default connect(mapStateToProps)(Trade);
